export const rgx = {
    price: /^(([\d]+|([\d]+.[\d]{1,2}))|([\s]{0,}[\d]+[\s]{0,}-[\s]{0,}[\d]+[\s]{0,}))$/g,
    tbcOrPrice: /^((tbc|TBC)|([\d]+|([\d]+.[\d]{1,2}))|([\s]{0,}[\d]+[\s]{0,}-[\s]{0,}[\d]+[\s]{0,}))$/g,
    url:  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,10}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    article: /^(.|[\n\r\t])+$/g,
    blank: /^\s*$/g,
    name: /^(.+)$/g,
    date: /^([\d]{2,2}\.[\d]{2,2}\.[\d]{2,2})$/g,
    time:  /^([\d]{2,2}\.[\d]{2,2})$/g,
}